"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
window['terminal'] = false;
if (document.URL.indexOf('terminal.html') >= 0 || document.URL.indexOf('terminal-admiral.html') >= 0) {
    window['terminal'] = true;
}
if (document.URL.indexOf('terminal-admiral.html') != -1) {
    if (location.host == 'online.admiralstage.elbet.com' || location.host == 'localhost' ||
        location.host == 'online.elbetdev.com' ||
        location.host == 'online.zb.elbet.com') {
    }
    else {
        location.href = 'https://online.elbet.com/lucky-balls/index.html';
    }
}
require('hacktimer');
require('../../../../node_modules/bootstrap/dist/js/bootstrap.min.js');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../ui/js/chart.min.js');
require('../../../ui/js/jquery-ui.js');
require('../../../ui/js/jquery.mCustomScrollbar.js');
require('../../../ui/js/charts.js');
window['lang'] = getUrlParam('lang');
window['language'] = window['lang'] === null ? 'en' : window['lang'];
window['help'] = getUrlParam('help');
window['term'] = getUrlParam('term');
require('../js/inactivity-handler.js');
require('../../../ui/js/language.js');
require('../js/common.js');
require('../js/script.js');
var chat_1 = require("../js/chat");
if (document.URL.indexOf('terminal-admiral.html') == -1) {
    require('../js/menu.js');
}
require('../js/balls.js');
require('../js/draw.js');
require('../js/game.js');
require('../js/infobar.js');
require('../js/results.js');
require('../js/luckyballs.js');
require('../js/points.js');
require('../js/socket.io.js');
require('../js/charts.js');
require('../../../ui/js/iframe-script.js');
if (window['terminal']) {
    require('../js/terminal.js');
}
if (document.URL.indexOf('terminal-admiral.html') == -1) {
    require('../video/regular_game.mp4');
    require('../video/intro_al.mp4');
    require('../video/intro_ba.mp4');
    require('../video/intro_de.mp4');
    require('../video/intro_en.mp4');
    require('../video/intro_es.mp4');
    require('../video/intro_fr.mp4');
    require('../video/intro_hr.mp4');
    require('../video/intro_it.mp4');
    require('../video/intro_mk.mp4');
    require('../video/intro_ro.mp4');
    require('../video/intro_rs.mp4');
    require('../video/intro_ru.mp4');
    require('../video/bonus_green.mp4');
    require('../video/bonus_yellow.mp4');
}
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
if (window['terminal']) {
    require('../scss/terminal/style.scss');
    require('../scss/terminal/jquery.numpad.scss');
}
else {
    console.log('Theme from static config: ', CSS_THEME);
    switch (window.location.hostname) {
        case "online.pinnbet.elbet.com":
            if (getUrlParam('theme') != null) {
                require("../scss/" + getUrlParam('theme') + ".scss");
                console.log('Special case [online.pinnbet.elbet.com] [online.elbetdev.com]  theme forced:', getUrlParam('theme'));
            }
            else {
                require("../scss/base.scss");
                console.log('Special case [online.pinnbet.elbet.com] [online.elbetdev.com]  theme base forced');
            }
            break;
        case BABAIJEBU_DOMAIN:
            try {
                require('../scss/' + CSS_THEME + '.scss');
                require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
            }
            catch (e) {
                console.info(e);
            }
            break;
        case "online.elbetdev.com":
            if (getUrlParam('theme') != null) {
                require("../scss/" + getUrlParam('theme') + ".scss");
                console.log('Special case [online.pinnbet.elbet.com] [online.elbetdev.com]  theme forced:', getUrlParam('theme'));
            }
            else {
                try {
                    require('../scss/' + CSS_THEME + '.scss');
                    require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
                }
                catch (e) {
                    console.info(e);
                }
            }
            break;
        case AMELCO_DOMAIN:
            try {
                require('../scss/' + CSS_THEME + '.scss');
                require('../scss/' + CSS_THEME + '/' + AMELCO_DOMAIN + '.scss');
            }
            catch (e) {
                console.info(e);
            }
            break;
        default:
            if (getUrlParam('theme') != null) {
                require("../scss/" + getUrlParam('theme') + ".scss");
                console.log('Special case [FOR ALL] [FORCED] theme :', getUrlParam('theme'));
            }
            else {
                if (location.hostname == 'online.soccer2.elbet.com' || location.hostname == 'online.stage.soccer.elbet.com') {
                    require('../scss/base.scss');
                    console.log('special:green ', CSS_THEME);
                }
                else {
                    require('../scss/' + CSS_THEME + '.scss');
                    console.log('All others load ', CSS_THEME);
                }
            }
    }
}
require('../../../ui/css/jquery.mCustomScrollbar.css');
var balls_1 = require("./balls/balls");
var chosen_balls_1 = require("./balls/chosen-balls");
var ticket_options_1 = require("./tickets/ticket-options");
var ticket_played_1 = require("./tickets/ticket-played");
var tickets_holder_1 = require("./tickets/tickets-holder");
var statistics_1 = require("./statistics/statistics");
var api_1 = require("./api/api");
var user_1 = require("./user/user");
var auth_1 = require("./auth/auth");
var login_modal_helper_1 = require("./helpers/login-modal-helper");
var credit_1 = require("./credit/credit");
var cookie_helper_1 = require("./helpers/cookie-helper");
var navbar_display_1 = require("./navbar/navbar-display");
var input_helper_1 = require("./helpers/input-helper");
var version_switcher_1 = require("./version-switcher/version-switcher");
window['API_URL'] = API_URL;
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
$(document).ready(function () {
    require('bootstrap-css');
    if (getUrlParam('interval') == null) {
        window.drawInterval = 3;
    }
    else {
        window.drawInterval = getUrlParam('interval');
        window.drawInterval = parseFloat(window.drawInterval);
        if (window.drawInterval > 5)
            window.drawInterval = 5;
    }
    var api = new api_1.default(API_URL + '/luckyballs');
    api.send('/game-config/get', {}, function (response) {
        window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] !== '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;
        window['useJackpot'] = (response['useJackpot'] !== undefined && response['useJackpot'] !== '' && response['useJackpot'] != null) ? true : false;
        window['LogoURL'] = (response['LogoURL'] !== undefined && response['LogoURL'] !== '' && response['LogoURL'] != null) ? response['LogoURL'] : 'header_elbet.png';
        window['purchaseConfirmation'] = (response['purchaseConfirmation'] !== undefined && response['purchaseConfirmation'] !== '' && response['purchaseConfirmation'] != null) ? response['purchaseConfirmation'] : 0;
        window['showLogin'] = (response['showLogin'] !== undefined && response['showLogin'] !== '' && response['showLogin'] != null) ? response['showLogin'] : 0;
        window['V4'] = (response['DisplayType'] !== undefined && response['DisplayType'] !== '' && response['DisplayType'] != null) ? response['DisplayType'] : 3;
        if ((window.V4 !== 4 || /terminal/.test(window.location.href)) && location.hostname != 'online.soccer2.elbet.com' && location.hostname != 'online.stage.soccer.elbet.com') {
            window['preload']();
            console.log("V3");
        }
        if (!(/terminal/.test(window.location.href))) {
            var versionSwitcher = new version_switcher_1.default();
            versionSwitcher.specificDomainChanges();
            if (window.V4 == 4 || location.hostname == 'online.soccer2.elbet.com' ||
                location.hostname == 'online.stage.soccer.elbet.com' ||
                location.host == 'online.elbetdev.com' ||
                location.host == 'online.zb.elbet.com') {
                if (location.host == 'online.elbetdev.com' ||
                    location.host == 'online.zb.elbet.com') {
                    versionSwitcher.switchForceV5();
                }
                else {
                    versionSwitcher.switch(window['V4']);
                }
            }
        }
        window['currency'] = response.Currency;
        $('#currency').text(window['currency']);
        window['customLoggedIn'] = false;
        window['customToken'] = '';
        if (window['showLogin'] !== 1 || cookie_helper_1.default.get('token') === '') {
            window['token'] = getUrlParam('token');
        }
        else {
            window['token'] = cookie_helper_1.default.get('token');
        }
        if (window['token'] && !/terminal/.test(window.location.href)) {
            chat_1.chat(window['token']);
        }
        if (window['menu'] && !/electron=true/.test(window.location.href)) {
            document.body.style.opacity = '1';
            $('#nav-icon1').show();
            $('.terminal-left').show();
            if (document.URL.indexOf('terminal-admiral.html') == -1) {
                window['renderMenu']();
            }
        }
        else {
            document.body.style.opacity = '1';
            var contentTab = document.querySelector('.terminal-content-tabs');
            var contentTabs = document.querySelector('.terminal-tabs');
            if (contentTab) {
                contentTab.classList.add('terminal-full-width');
            }
            if (contentTabs) {
                contentTabs.classList.add('terminal-full-width');
            }
        }
        switch (response['ManualCombMinCombBet']) {
            case -1:
                window['allColorsMinBet'] = response['Bingo_MinBet'] * 8;
                break;
            case 0:
                window['allColorsMinBet'] = response['Bingo_MinBet'] * 8;
                break;
            case 1:
                window['allColorsMinBet'] = response['Bingo_MinBetCombination'] * 8;
                break;
        }
        if (window['showLogin'] === 1) {
            $('.game-nav-bar').css('display', 'flex');
        }
        else {
            $('.game-nav-bar').css('display', 'none');
        }
        showBettingValues(response);
    }, function () { });
    var balls = new balls_1.default();
    var chosenBalls = new chosen_balls_1.default(balls);
    var ticketOptions = new ticket_options_1.default(chosenBalls, api);
    var ticketsHolder = new tickets_holder_1.default();
    var user = new user_1.default();
    var auth = new auth_1.default(api);
    var credit = new credit_1.default(api);
    var navbar = new navbar_display_1.default();
    ticketOptions.attachListeners();
    window.addEventListener('get_tickets_no_stats', function () {
        getTickets(api, ticketsHolder);
    });
    window['loggedOut'] = new Event('loggedOut');
    window.addEventListener('get_tickets', function () {
        getStatistics(api);
        getTickets(api, ticketsHolder);
    });
    window.addEventListener('update_tickets', function () {
        if (window['ticketsTaken'] !== true) {
            getStatistics(api);
            getTickets(api, ticketsHolder);
        }
        ticketsHolder.updateTickets();
    });
    window.addEventListener('logout', function () {
        auth.logout();
    });
    window.addEventListener('getTicket', function (e) {
        getTicket(api, e.detail.ticketId, e.detail);
    });
    window.addEventListener('get_credit', function () {
        credit.getCredit(user);
    });
    window.addEventListener('payout', function () {
        credit.requestPayout(user);
    });
    loginManagement(auth, user, navbar, credit);
});
$('.payout-pin-button').click(function () {
    var payoutEvent = new CustomEvent('payout');
    window.dispatchEvent(payoutEvent);
});
function getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}
function showBettingValues(response) {
    window['Bingo_MinBet'] = response['Bingo_MinBet'];
    window['Bingo_MinBetCombination'] = response['Bingo_MinBetCombination'];
    $('#betting-values').show();
    $('#min-bet').text(response['Bingo_MinBet']).attr('data-value', response['Bingo_MinBet']);
    $('#max-bet').text(response['Bingo_MaxBet']).attr('data-value', response['Bingo_MaxBet']);
    $('#bet-100').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
    $('#bet-200').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
    $('#bet-400').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
    $('[data-predefined="1"]').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
    $('[data-predefined="2"]').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
    $('[data-predefined="3"]').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
    $('[data-predefined="min"]').attr('data-value', response['Bingo_MinBet']);
    $('[data-predefined="max"]').attr('data-value', response['Bingo_MaxBet']);
    $('#betting-btn').val(parseFloat(response['Bingo_MinBet']).toFixed(2))
        .attr('min', response['Bingo_MinBet'])
        .attr('max', response['Bingo_MaxBet'])
        .attr('step', response['Bingo_MinBet']);
}
function getStatistics(api) {
    api.send('/statistics/get', { 'noOfGames': 30 }, function (response) {
        var stats = new statistics_1.default(response['Data']['BingoStats'][0]);
        $('#betting-advanced').show();
        stats.show();
    }, function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });
}
function getTickets(api, ticketsHolder) {
    ticketsHolder.clearTickets();
    window['ticketsTaken'] = true;
    api.send('/ticket/get', { 'SessionID': window['token'] }, function (response) {
        var tickets = {};
        if ('OpenTickets' in response) {
            if (Number(response['OpenTickets']) > 0) {
                document.querySelector('.open-tickets-hidden') ?
                    document.querySelector('.open-tickets-hidden').innerHTML = "(+" + response['OpenTickets'] + ")" : '';
                document.querySelector('.open-tickets') ?
                    document.querySelector('.open-tickets').innerHTML = "(+" + response['OpenTickets'] + ")" : '';
            }
            else {
                document.querySelector('.open-tickets-hidden') ?
                    document.querySelector('.open-tickets-hidden').innerHTML = '' : '';
                document.querySelector('.open-tickets') ?
                    document.querySelector('.open-tickets').innerHTML = '' : '';
            }
        }
        for (var key in response['Data']['BingoTicket']) {
            var ticketID = response['Data']['BingoTicket'][key]['TicketID'];
            var ticketAmount = response['Data']['BingoTicket'][key]['TicketAmount'];
            if (typeof tickets[ticketID] === 'undefined') {
                tickets[ticketID] = [];
            }
            var roundsTotal = (response['Data']['BingoTicket'][key]['RoundsTotal'] !== undefined && response['Data']['BingoTicket'][key]['RoundsTotal'] !== '' && response['Data']['BingoTicket'][key]['RoundsTotal'] != null) ? response['Data']['BingoTicket'][key]['RoundsTotal'] : '';
            var currentRound = (response['Data']['BingoTicket'][key]['CurrentRound'] !== undefined && response['Data']['BingoTicket'][key]['CurrentRound'] !== '' && response['Data']['BingoTicket'][key]['CurrentRound'] != null) ? response['Data']['BingoTicket'][key]['CurrentRound'] : '';
            tickets[ticketID].push({
                'TicketID': ticketID,
                'TicketAmount': ticketAmount,
                'OddType': response['Data']['BingoTicket'][key]['OddType'],
                'Odd': response['Data']['BingoTicket'][key]['Odd'],
                'Numbers': response['Data']['BingoTicket'][key]['Numbers'],
                'JPCode': response['Data']['BingoTicket'][key]['JPCode'],
                'RoundID': response['Data']['BingoTicket'][key]['ItemTodayGameID'],
                'RoundsTotal': roundsTotal,
                'CurrentRound': currentRound
            });
        }
        ticketsHolder.clearTickets();
        var ticket;
        for (var key in tickets) {
            if (typeof window['jackpotObj'] === 'object' && Object.keys(window['jackpotObj']).length) {
                if (tickets[key][0]['JPCode'].trim() !== "" && window['jackpotObj'].jackpotCode.trim() !== "") {
                    if (String(tickets[key][0]['JPCode']) === String(window['jackpotObj'].jackpotCode)) {
                        var showJackpotEvent_1 = new CustomEvent('showJackpotEvent', { detail: window['jackpotObj'] });
                        window.dispatchEvent(showJackpotEvent_1);
                        ticket = new ticket_played_1.default(tickets[key], ticketsHolder, true);
                    }
                    else {
                        ticket = new ticket_played_1.default(tickets[key], ticketsHolder);
                        if (document.querySelector('.jackpot-informer'))
                            document.querySelector('.jackpot-informer').style.display = 'none';
                    }
                }
                else {
                    ticket = new ticket_played_1.default(tickets[key], ticketsHolder);
                    if (document.querySelector('.jackpot-informer'))
                        document.querySelector('.jackpot-informer').style.display = 'none';
                }
            }
            else {
                ticket = new ticket_played_1.default(tickets[key], ticketsHolder);
                if (document.querySelector('.jackpot-informer'))
                    document.querySelector('.jackpot-informer').style.display = 'none';
            }
            ticketsHolder.addTicket(ticket);
        }
        if (!Object.keys(tickets).length) {
            if (document.querySelector('.jackpot-informer')) {
                document.querySelector('.jackpot-informer').style.display = 'none';
            }
        }
        ticketsHolder.showTickets();
    }, function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });
}
function getTicket(api, id, ticketData) {
    api.send('/ticket/get/id', { 'ticketId': id }, function (response) {
        if (response.TicketData) {
            if (response.TicketData.TicketData.length > 0) {
                var numbers = response.TicketData.TicketData[0].
                    Numbers.replace(/\|/g, ',').substring(1).slice(0, -1).
                    split(',').map(function (numbero) {
                    return parseInt(numbero, 10);
                });
                numbers.sort(function (a, b) { return a - b; });
                var respObj = {
                    selectedNumbers: numbers,
                    winMoney: response.TicketData.TicketData[0].WinMoney,
                    bonusMoney: response.TicketData.TicketData[0].BonusMoney,
                    jPWinMoney: response.TicketData.TicketData[0].JPWinMoney,
                    happyGameMoney: response.TicketData.TicketData[0].HappyGameMoney,
                    payout: response.TicketData.TicketData[0].Payout,
                    ticketAmount: response.TicketData.TicketData[0].TicketAmount,
                    ticketStatus: response.TicketData.TicketData[0].TicketStatus
                };
                Object.assign(ticketData, respObj);
                var shareTicketEvent = new CustomEvent('shareTicketEvent', {
                    bubbles: true,
                    detail: ticketData
                });
                window.dispatchEvent(shareTicketEvent);
                return response;
            }
        }
    }, function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });
}
function loginManagement(auth, user, navbar, credit) {
    if (user.isLogggedIn()) {
        window['token'] = cookie_helper_1.default.get('token');
        var response = {
            Data: {
                AuthUserResponse: [
                    {
                        Credit: credit.getCredit(user),
                        Currency: cookie_helper_1.default.get('currency')
                    }
                ]
            }
        };
        navbar.showLogedIn(user, response);
    }
    else {
        navbar.showLogedOut();
    }
    $('.logout-button').click(function () {
        var logoutEvent = new CustomEvent('logout');
        window.dispatchEvent(logoutEvent);
    });
    $('.login-button').click(function () {
        $('.login-modal').modal('show');
    });
    $('.login-user-button').click(function () {
        auth.login(login_modal_helper_1.default.bind(user));
    });
    $('.user-username').on('keydown', function (e) {
        if (e.which === 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.user-password').on('keydown', function (e) {
        if (e.which === 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
    var ticketPinInput = document.getElementById('betting-btn');
    input_helper_1.default.setInputFilter(ticketPinInput, function (value) {
        return /^\d*\.?\d*$/.test(value);
    });
    if (ticketPinInput) {
        ticketPinInput.oninput = function () {
            input_helper_1.default.setMaxInputLength(ticketPinInput, 8);
            input_helper_1.default.setInputFilter(ticketPinInput, function (value) {
                return /^\d*\.?\d*$/.test(value);
            });
        };
    }
    var roundsInput = document.getElementById('subscription-btn');
    input_helper_1.default.setInputFilter(roundsInput, function (value) {
        return /^\d{1,2}[\W_]?/.test(value);
    });
    if (roundsInput) {
        roundsInput.oninput = function () {
            input_helper_1.default.setMaxInputLength(roundsInput, 2);
            input_helper_1.default.setInputFilter(roundsInput, function (value) {
                return /^\d*\.?\d*$/.test(value);
            });
        };
    }
}
window['appVersion'] = "V0.1.2.4";
console.log('Release: V0.1.2.1');



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/main.ts
// module id = 836
// module chunks = 2